import FormDialog from "../../../components/dialog/form/FormDialog.vue";
import SelectField from "../../../components/fields/selectField/SelectField.vue";
import TextField from "../../../components/fields/textField/TextField.vue";
import PeriodoField from "../../../components/fields/periodoField/PeriodoField.vue";
import { ServidorCivil } from "../../../constants";
import { FeriasService } from "../../../services/FeriasService";
import { CivilService } from "../../../services/CivilService";
import { numeroBmMixin } from "../../../mixins/numeroBmMixin";


export default {
  name: "PesquisarCivil",

  components: {
    FormDialog,
    SelectField,
    TextField,
    PeriodoField,

  },

  mixins:[numeroBmMixin],

  data: () => ({
    totalItems: 0,
    headers: [
      { text: "Nº BM", value: "numero", sortable: true },
      { text: "Nome Civil", value: "nome", sortable: true },
      { text: "Unidade/Lotação", value: "unidade", sortable: true },
      { text: "Servidor Civil", value: "tipo_civil", sortable: true },
      { text: "Ano de Corporação", value: "ano_corporacao", sortable: true },
    ],
    data: [],
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    loading: {
      table: false,
      btn: false,
      field: false,
    },

    filter: {},



    optionsFilter: {
      unidadeLotacao: [],
      servidorCivil: ServidorCivil
    },
  }),

  beforeMount() {
    this.getUnidadeItems();
    this.getCivil();
    this.getCivil();
  },

  
  watch: {

    page: async function(val) {
      this.page = val;
      await this.getCivil();
    },
  },

  methods: {

    initializeFilter() {
      this.filter = {
        numero: null,
        nome: null,
        unidade: null,
        tipo_civil:null,
        ano_corporacao: null
      };
    },

    prepareFormFilter() {
      const filter = new FormData();

      filter.append("page", this.page);
      this.filter.numero ? this.removerZero(filter.append("numero",this.filter.numero.replace("-", "").replace(".", ""))) : null;
      this.filter.nome ? filter.append("nome",this.filter.nome) : null;
      this.filter.unidade ? filter.append("unidade",this.filter.unidade) : null;
      this.filter.tipo_civil ? filter.append("tipo_civil",this.filter.tipo_civil) : null;
      this.filter.ano_corporacao ? filter.append("ano_corporacao",this.filter.ano_corporacao) : null;
      return filter;
    },

    
    async getCivil() {
      this.loading.table = true;
      const filter = this.prepareFormFilter();
      const response = await CivilService.pesquisar(filter);

      this.data = response.data;
      this.pageCount = response.last_page;
      this.totalItems = response.total;
      this.loading.table = false;
      this.$forceUpdate();


    },

    async alterarDataCorp (valor){
      const formData = new FormData();

      formData.append("data_ini_corp", valor.ano_corporacao);
      formData.append("IdSigrh", valor.id);
      await CivilService.alterarDataCorp(formData);

    },

    async getUnidadeItems() {
      this.loading.field = true;
      const response = await FeriasService.getUnidade();
      this.optionsFilter.unidadeLotacao = response.map((el) => {
        return {
          text: el.nome_abreviado,
          value: el.id,
        };
      });
      this.optionsFilter.unidadeLotacao?.unshift({
        text: "Selecione",
        value: "",
      });
      this.loading.field = false;
    }, 
  },
};
